(()=>{
  const LOGO='https://cdn.shopify.com/s/files/1/0759/3515/4212/files/gc-tabby-logo.png?v=1788537875';

  const esc=s=>String(s).replace(/[&<>'"]/g,c=>({
    '&':'&amp;',
    '<':'&lt;',
    '>':'&gt;',
    "'":'&#39;',
    '"':'&quot;'
  }[c]));

  const icons={
    calendar:'<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><rect x="4" y="5" width="16" height="15" rx="2" stroke="currentColor" stroke-width="2"/><path d="M8 3v4M16 3v4M4 10h16" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
    bag:'<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 8h14l-1 12H6L5 8Z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/><path d="M9 9V6a3 3 0 0 1 6 0v3" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
    check:'<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 3l2 2.2 3-.3.7 2.9 2.6 1.5-1.2 2.8 1.2 2.8-2.6 1.5-.7 2.9-3-.3L12 21l-2-2.2-3 .3-.7-2.9-2.6-1.5 1.2-2.8-1.2-2.8 2.6-1.5.7-2.9 3 .3L12 3Z" stroke="currentColor" stroke-width="1.7"/><path d="m8.5 12 2.2 2.2 4.8-5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    card:'<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" stroke-width="2"/><path d="M3 9h18M7 15h4" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>'
  };

  function ensureModal(){
    let m=document.getElementById('gcTabbyModal');

    if(m) return m;

    m=document.createElement('div');
    m.id='gcTabbyModal';
    m.className='gc-tabby-modal';
    m.setAttribute('role','dialog');
    m.setAttribute('aria-modal','true');
    m.setAttribute('aria-labelledby','gcTabbyTitle');

    m.innerHTML=`
      <div class="gc-tabby-modal__backdrop" data-gc-tabby-close></div>

      <div class="gc-tabby-modal__panel" tabindex="-1">

        <section class="gc-tabby-modal__hero">

          <button
            type="button"
            class="gc-tabby-modal__close"
            aria-label="Close Tabby information"
            data-gc-tabby-close
          >
            &times;
          </button>

          <h2 class="gc-tabby-modal__title" id="gcTabbyTitle">
            Pay for your purchase, split it with Tabby
          </h2>

          <span class="gc-tabby-modal__brand-wrap">
            <img
              class="gc-tabby-modal__brand"
              src="${esc(LOGO)}"
              alt="Tabby"
            >
          </span>

        </section>

        <div class="gc-tabby-modal__highlight">

          <span class="gc-tabby-modal__feature-icon">
            ${icons.calendar}
          </span>

          <strong>
            Pay in 4 monthly payments
          </strong>

          <span class="gc-tabby-modal__feature-sub">
            No interest or hidden fees
          </span>

        </div>

        <section class="gc-tabby-modal__body">

          <h3>
            Ready to complete your purchase?
          </h3>

          <div class="gc-tabby-modal__steps">

            <div class="gc-tabby-modal__step">
              <span class="gc-tabby-modal__step-icon">
                ${icons.bag}
              </span>
              <p>Shop your favourites</p>
            </div>

            <span
              class="gc-tabby-modal__connector"
              aria-hidden="true"
            ></span>

            <div class="gc-tabby-modal__step">
              <span class="gc-tabby-modal__step-icon">
                ${icons.check}
              </span>
              <p>Choose Tabby at checkout</p>
            </div>

            <span
              class="gc-tabby-modal__connector"
              aria-hidden="true"
            ></span>

            <div class="gc-tabby-modal__step">
              <span class="gc-tabby-modal__step-icon">
                ${icons.card}
              </span>
              <p>Pay your first payment now</p>
            </div>

          </div>

          <div class="gc-tabby-modal__footer">
            Shop now.
            <em>Pay over time with Tabby.</em>
          </div>

          <p class="gc-tabby-modal__note">
            Tabby availability and approval are subject to eligibility.
            Payments are split into 4 monthly payments.
            If a payment is missed in the UAE, collection fees may apply.
            Final terms are shown by Tabby before confirmation.
          </p>

        </section>

      </div>
    `;

    document.body.appendChild(m);

    m.addEventListener('click',e=>{
      if(e.target.closest('[data-gc-tabby-close]')){
        closeModal();
      }
    });

    return m;
  }


  function openModal(){
    const m=ensureModal();

    m.classList.add('is-open');
    document.body.classList.add('gc-tabby-modal-open');

    setTimeout(()=>{
      m.querySelector('.gc-tabby-modal__panel')?.focus();
    },0);
  }


  function closeModal(){
    const m=document.getElementById('gcTabbyModal');

    if(!m) return;

    m.classList.remove('is-open');
    document.body.classList.remove('gc-tabby-modal-open');
  }


function info(context){
  const el=document.createElement('div');

  el.className=`gc-tabby-info gc-tabby-info--${context}`;

  const footer=context==='footer';
  const cart=context==='cart';

  el.innerHTML=`
    <div class="gc-tabby-copy">

      ${
        footer
        ? '<span>Flexible payments with</span>'
        : cart
        ? '<span>Split your purchase into 4 payments with</span>'
        : `
            <strong>Pay in 4 with Tabby</strong>
            <span>No interest or fees when paid on time.</span>
          `
      }

      ${
        footer
        ? ''
        : `
            <button
              type="button"
              class="gc-tabby-learn"
            >
              Learn more
            </button>
          `
      }

    </div>

    <button
      type="button"
      class="gc-tabby-logo-btn"
      aria-label="Learn about paying with Tabby"
    >
      <img
        class="gc-tabby-logo"
        src="${esc(LOGO)}"
        alt="Tabby"
        loading="lazy"
      >
    </button>
  `;

  el.querySelectorAll(
    '.gc-tabby-logo-btn,.gc-tabby-learn'
  ).forEach(button=>{
    button.addEventListener('click',openModal);
  });

  return el;
}
  /*
   * Find MAIN PRODUCT section.
   */
  function getProductSections(){

    const result=[];
    const seen=new Set();

    const selectors=[
      '[id^="MainProduct-"]',
      '.m-main-product',
      '.m-main-product--wrapper',
      'product-info'
    ];

    selectors.forEach(selector=>{

      document.querySelectorAll(selector).forEach(el=>{

        let root=
          el.closest('[id^="MainProduct-"]') ||
          el.closest('.m-main-product') ||
          el;

        if(!root || seen.has(root)) return;

        seen.add(root);
        result.push(root);

      });

    });

    return result;
  }


  /*
   * Is element actually visible?
   */
  function isVisible(el){

    if(!el) return false;

    const style=window.getComputedStyle(el);

    if(
      style.display==='none' ||
      style.visibility==='hidden'
    ){
      return false;
    }

    return el.getClientRects().length>0;
  }


  /*
   * FIND MOBILE PRICE
   *
   * We check several possible classes because your theme
   * has custom mobile product markup.
   */
  function findMobilePrice(root){

    const selectors=[

      '.gc-mobile-product-price',

      '[data-gc-mobile-price]',

      '.gc-mobile-product-meta .product-block-group--price',

      '.gc-mobile-title-price .product-block-group--price',

      '.gc-mobile-meta .product-block-group--price',

      '.for_mobile .product-block-group--price',

      '.for_mobile [id^="Price-"]',

      '.m-product-info--wrapper .product-block-group--price:not(.for_desktop)',

      '.m-main-product--info .product-block-group--price:not(.for_desktop)'

    ];


    for(const selector of selectors){

      const elements=root.querySelectorAll(selector);

      for(const el of elements){

        if(isVisible(el)){
          return el;
        }

      }

    }


    /*
     * Final fallback:
     * find any visible product price which is not desktop-only.
     */
    const prices=root.querySelectorAll(
      '.product-block-group--price,[id^="Price-"]'
    );

    for(const price of prices){

      if(
        isVisible(price) &&
        !price.classList.contains('for_desktop')
      ){
        return price;
      }

    }

    return null;
  }


  /*
   * Desktop price.
   */
  function findDesktopPrice(root){

    const selectors=[

      '.product-block-group--price.for_desktop',

      '.main-product__block-price .product-block-group--price',

      '.m-product-info--wrapper .product-block-group--price'

    ];


    for(const selector of selectors){

      const el=root.querySelector(selector);

      if(el){
        return el;
      }

    }

    return null;
  }


  /*
   * MOBILE TITLE container fallback.
   *
   * If price itself cannot be found but the new mobile
   * title/price wrapper exists, Tabby can still be positioned
   * directly before Colour/variants.
   */
  function findMobileMeta(root){

    const selectors=[

      '.gc-mobile-product-meta',

      '.gc-mobile-title-price',

      '.gc-mobile-meta',

      '[data-gc-mobile-meta]'

    ];

    for(const selector of selectors){

      const el=root.querySelector(selector);

      if(el && isVisible(el)){
        return el;
      }

    }

    return null;
  }


  function placeProductTabby(){

    const mobile=
      window.matchMedia(
        '(max-width: 767px)'
      ).matches;


    getProductSections().forEach(root=>{

      let tabby=
        root.querySelector(
          '.gc-tabby-info--product'
        );


      if(!tabby){

        tabby=info('product');

      }


      /*
       * MOBILE
       */
      if(mobile){

        const price=findMobilePrice(root);


        /*
         * Priority #1:
         * Actual visible mobile Price.
         */
        if(price){

          if(
            tabby.parentElement !== price.parentElement ||
            tabby.previousElementSibling !== price
          ){

            price.insertAdjacentElement(
              'afterend',
              tabby
            );

          }

          return;
        }


        /*
         * Priority #2:
         * Mobile Title + Price wrapper.
         */
        const meta=findMobileMeta(root);

        if(meta){

          if(
            tabby.parentElement !== meta.parentElement ||
            tabby.previousElementSibling !== meta
          ){

            meta.insertAdjacentElement(
              'afterend',
              tabby
            );

          }

          return;
        }


        /*
         * Priority #3:
         * Put Tabby immediately before Colour/Size block.
         *
         * That keeps desired order:
         *
         * Title
         * Price
         * Tabby
         * Colour
         * Size
         */
        const variantBlock=
          root.querySelector(
            '.main-product__block-variant_picker'
          ) ||
          root.querySelector(
            'variant-selects'
          ) ||
          root.querySelector(
            '.m-product-option'
          );


        if(variantBlock && variantBlock.previousElementSibling !== tabby){

          variantBlock.insertAdjacentElement(
            'beforebegin',
            tabby
          );

        }

        return;
      }


      /*
       * DESKTOP
       */
      const desktopPrice=findDesktopPrice(root);

      if(desktopPrice){

        if(
          tabby.parentElement !== desktopPrice.parentElement ||
          tabby.previousElementSibling !== desktopPrice
        ){

          desktopPrice.insertAdjacentElement(
            'afterend',
            tabby
          );

        }

      }

    });

  }


  /*
   * CART DRAWER
   */
  function addCart(){

    document.querySelectorAll(
      '#MinimogCartDrawer .m-cart__subtotal'
    ).forEach(sub=>{

      const host=sub.parentElement;

      if(!host) return;

      let tabby=
        host.querySelector(
          ':scope > .gc-tabby-info--cart'
        );

      if(!tabby){

        tabby=info('cart');

        sub.insertAdjacentElement(
          'afterend',
          tabby
        );

      }

    });

  }


  /*
   * FOOTER
   */
  function addFooter(){

    document.querySelectorAll(
      '.m-footer--bottom-inner'
    ).forEach(bottom=>{

      let tabby=
        bottom.querySelector(
          ':scope > .gc-tabby-info--footer'
        );

      if(!tabby){

        tabby=info('footer');
        bottom.prepend(tabby);

      }

    });

  }


  let queued=false;


  function apply(){

    queued=false;

    placeProductTabby();
    addCart();
    addFooter();

  }


  function queue(){

    if(queued) return;

    queued=true;

    requestAnimationFrame(apply);

  }


  document.addEventListener(
    'keydown',
    e=>{

      if(e.key==='Escape'){
        closeModal();
      }

    }
  );


  window.addEventListener(
    'resize',
    queue,
    {
      passive:true
    }
  );


  if(document.readyState==='loading'){

    document.addEventListener(
      'DOMContentLoaded',
      apply,
      {
        once:true
      }
    );

  }else{

    apply();

  }


  /*
   * Shopify variant/product sections can re-render,
   * therefore position Tabby again when DOM changes.
   */
  const observer=
    new MutationObserver((mutations)=>{
      const relevant=mutations.some(m=>[...m.addedNodes,...m.removedNodes].some(node=>
        node.nodeType===1 && !node.matches('.gc-tabby-info, .gc-tabby-info *') &&
        (node.matches('m-cart-drawer,.m-cart__subtotal,.m-product-info,variant-selects,.shopify-section') ||
         node.querySelector('.m-cart__subtotal,.m-product-info,variant-selects') ||
         m.target.closest?.('.m-product-info,#MinimogCartDrawer'))
      ));
      if(relevant) queue();
    });

  observer.observe(
    document.documentElement,
    {
      childList:true,
      subtree:true
    }
  );


  /*
   * Extra checks for app/theme delayed rendering.
   */
  setTimeout(apply,300);
  setTimeout(apply,800);
  setTimeout(apply,1500);
  setTimeout(apply,3000);

})();
